import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ProtectedRoute from '../utils/ProtectedRoute';

const RoleBasedRouter: React.FC<{ roles: string[] }> = ({ roles }) => {
  return (
    <Router>
      <Routes>
        <Route path="/admin/*" element={<ProtectedRoute roles={['admin']} />} />
        <Route path="/user/*" element={<ProtectedRoute roles={['user']} />} />
      </Routes>
    </Router>
  );
};

export default RoleBasedRouter;
